<template>
  <div v-clickOutside="close" class="relative">
    <div class="mr-5 cursor-pointer" @click.stop="open">
      <svg class="w-16 h-16" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="22.5" cy="22.5" r="18.5" :stroke="`#${computedColor}`" stroke-width="8" />
      </svg>
    </div>

    <div
      v-if="showDropdown"
      class="absolute z-50 top-30 rounded-8 flex flex-wrap justify-between w-185 p-7 -m-7 shadow-dropdown"
      :class="[isDarkMode ? 'bg-sidebar' : 'bg-white', position]"
    >
      <div
        v-for="c in colors"
        :key="c"
        class="rounded-6 anim-color-200 p-7 cursor-pointer"
        :class="[isDarkMode ? 'hover:bg-dark-500' : 'hover:bg-menu-hover']"
        @click.stop="save(c)"
      >
        <svg class="w-20 h-20" width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="22.5" cy="22.5" r="18.5" :stroke="`#${c.toString(16)}`" stroke-width="8" />
        </svg>
      </div>

      <div
        v-if="color"
        class="flex items-center p-7 pb-0 text-12 text-app-color opacity-50
                 hover:opacity-100 cursor-pointer transition duration-300"
        @click.stop="save(null)"
      >
        <i class="icon-remove mr-5" />
        <p>Remove circle</p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    color: Number,
    position: { type: String, default: 'left-1/2 transform -translate-x-1/2' }
  },

  emits: ['updateColor'],

  setup (props, { emit }) {
    const { getters } = useStore()

    const showDropdown = ref(false)

    const colors = [6250495, 16772959, 16736095, 6291359, 6284031, 12189535, 12148735, 6291426, 16758111, 16736239]

    const computedColor = computed(() => props.color?.toString(16) || 'ccc')

    const isDarkMode = computed(() => getters.isDarkMode)

    function open () {
      showDropdown.value = true
    }

    function close () {
      showDropdown.value = false
    }

    function save (value) {
      emit('updateColor', value)
      close()
    }

    return {
      // refs
      // data
      colors,
      showDropdown,
      // computed
      isDarkMode,
      computedColor,
      // functions
      save,
      open,
      close
    }
  }
})
</script>
